import React, { useState } from 'react';
import { createDataTable } from '@/components/DataTable';
import { SortDirection } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { getOutgoingEmails, MessageStatusFilter, OutgoingEmailLogItem } from '@/services/communicore';
import { Button } from '@ygtechnologies/rubus-ui';
import { DateTimeDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { MessageStatusCell, StatusFilterSelect } from './shared';
import OutgoingEmailDetailsModal from './OutgoingEmailDetailsModal';

const DataTable = createDataTable<OutgoingEmailLogItem>();

const OutgoingEmailsTable: React.FC = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('createdAt', SortDirection.Descending, 25));
    const [statusFilter, setStatusFilter] = useState<MessageStatusFilter>('');
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [data, , , isLoading] = useAsyncStateWithIsLoading(
        () => getOutgoingEmails(tableState, statusFilter),
        [tableState, statusFilter],
        null
    );

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <DataTable
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                toolbarActions={<StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />}
                className="table style-3">
                <DataTable.Column
                    header="Created"
                    field="createdAt"
                    renderer={(x) => <DateTimeDisplay value={x.value} />}
                />
                <DataTable.Column header="To" field="to" renderer={(x) => x.value.join(', ')} />
                <DataTable.Column header="Subject" field="subject" />
                <DataTable.Column
                    header="Status"
                    field="status"
                    renderer={({ row }) => <MessageStatusCell status={row.status} lastError={row.lastError} />}
                />
                <DataTable.Column
                    header="Attempts"
                    field="attemptCount"
                    renderer={({ row }) => `${row.attemptCount} / ${row.maxAttempts}`}
                />
                <DataTable.Column header="Attachments" field="attachmentCount" />
                <DataTable.Column
                    header=""
                    field="id"
                    renderer={({ row }) => (
                        <Button size="xs" variant="tertiary" onClick={() => setSelectedId(row.id)}>
                            Details
                        </Button>
                    )}
                />
            </DataTable>
            {selectedId && <OutgoingEmailDetailsModal id={selectedId} onClose={() => setSelectedId(null)} />}
        </div>
    );
};

export default OutgoingEmailsTable;
